import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updatePeriodIncrease(state, { id, data }) {
      // 变更状态
      // eslint-disable-next-line no-param-reassign
      data.time = new Date().getTime();
      Vue.set(state.fund, id, data);
    },
    updateNetList(state, { id, data }) {
      // 变更状态
      // eslint-disable-next-line no-param-reassign
      data.ctime = new Date().getTime();
      state.fund[`${id.id}NetList`] = data;
    },
    updateFundMNBasicInfoWarinfo(state, { id, data }) {
      // 变更状态
      state.fund[`${id}FundMNBasicInfoWarinfo`] = data;
    },
    updateFundBarList(state, { id, data }) {
      // 变更状态
      state.fund[`${id}FundBarList`] = data;
    },
    updateSubAccount(state, { id, data }) {
      // 变更状态
      state.fund[`${id}subAccount`] = data;
    },
    updateFundMNInverstPosition(state, { id, data }) {
      // 变更状态
      state.fund[`${id}FundMNInverstPosition`] = data;
    },
    updateFundMNInverstPositionNew(state, { id, data }) {
      // 变更状态
      state.fund[`${id}FundMNInverstPositionNew`] = data;
    },
    updateFundInfo(state, { id, data }) {
      // 变更状态
      state.fund[`${id}FundInfo`] = data;
    },
    updateFundMNBonusPoints(state, { id, data }) {
      // 变更状态
      state.fund[`${id}BonusPoints`] = data;
    },
    updateCancelLikePost(state, { id, data }) {
      // 变更状态
      state.fund[`${id}CancelLikePost`] = data;
    },
    updateLikePost(state, { id, data }) {
      // 变更状态
      state.fund[`${id}LikePost`] = data;
    },
    updateFundMNTagList(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}TagList`, data);
    },
    updateFundMNStopWatch(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}updateFundMNStopWatch`, data);
    },
    updateShowByProductCode(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}showByProductCode`, data);
    },
    updateUserDynamicListCode(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}UserDynamicListCode`, data);
    },
    updateWxConfigure(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}WxConfigure`, data);
    },
    updateADConfigure(state, { id, data }) {
      Vue.set(state.fund, `${id.fundcode}ADConfigurenew`, data);
    },
    updatefundbaseinfos(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, `${id}fundbaseinfos`, data);
    },
  },
  actions: {
    updateNetList({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getNetList', id)
          .then((json) => {
            commit('updateNetList', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateFundMNBasicInfoWarinfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNBasicInfoWarinfo', id)
          .then((json) => {
            commit('updateFundMNBasicInfoWarinfo', {
              id,
              data: json.Datas,
            });
            resolve(json.Datas);
          }).catch((error) => reject(error));
      });
    },
    updateWxConfigure({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('ConfigApi.getWxConfigure', id)
          .then((json) => {
            commit('updateWxConfigure', {
              id,
              data: json.datas,
            });
            resolve(json.datas);
          }).catch((error) => reject(error));
      });
    },
    updateADConfigure({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('ConfigApi.getFundConfigure', id.fundcode)
          .then((json) => {
            commit('updateADConfigure', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateFundInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundInfo', id)
          .then((json) => {
            commit('updateFundInfo', {
              id,
              data: json.Datas,
            });
            resolve(json.Datas);
          }).catch((error) => reject(error));
      });
    },
    updateFundBarList({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('JijinbaApi.getFundbarList', id)
          .then((json) => {
            commit('updateFundBarList', {
              id,
              data: json,
            });
            resolve(json.Data);
          }).catch((error) => reject(error));
      });
    },
    async updatePeriodIncrease({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getPeriodIncrease', id)
          .then((json) => {
            commit('updatePeriodIncrease', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    async updateFundMNBonusPoints({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNBonusPoints', id)
          .then((json) => {
            commit('updateFundMNBonusPoints', {
              id,
              data: json.Datas,
            });
            resolve(json.Datas);
          }).catch((error) => reject(error));
      });
    },
    async updateFundMNInverstPosition({ commit }, id) {
      // let json = await quotation.getPeriodIncrease(id)
      const json = await Vue.prototype.$http.useRequests('FundApi.getFundMNInverstPosition', id);
      const invData = json.Datas;
      if (json.Expansion) {
        invData.Expansion = json.Expansion;
      }
      commit('updateFundMNInverstPosition', {
        id,
        data: invData,
      });
    },
    async updateFundMNInverstPositionNew({ commit }, id) {
      // let json = await quotation.getPeriodIncrease(id)
      const json = await Vue.prototype.$http.useRequests('FundApi.getFundMNInverstPositionNew', id);
      const invData = json.Datas;
      if (json.Expansion) {
        invData.Expansion = json.Expansion;
      }
      commit('updateFundMNInverstPositionNew', {
        id,
        data: invData,
      });
    },
    updateSubAccount({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('GroupApi.getFundHoldsBySubAccount', id)
          .then((json) => {
            commit('updateSubAccount', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateCancelLikePost({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('JijinbaApi.setCancelLikePost', id)
          .then((json) => {
            commit('updateCancelLikePost', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateLikePost({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('JijinbaApi.setLikePost', id)
          .then((json) => {
            commit('updateLikePost', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateFundMNTagList({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNTagList', id)
          .then((json) => {
            commit('updateFundMNTagList', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateFundMNStopWatch({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNStopWatch', id)
          .then((json) => {
            commit('updateFundMNStopWatch', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateShowByProductCode({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('DataappiApi.getShowByProductCode', id)
          .then((json) => {
            commit('updateShowByProductCode', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateUserDynamicListCode({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('DataappiApi.getuserDynamicListCode', id)
          .then((json) => {
            commit('updateUserDynamicListCode', {
              id,
              data: json.data,
            });
            resolve(json.data);
          }).catch((error) => reject(error));
      });
    },
    updatefundbaseinfos({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('DataappiApi.getfundbaseinfos', id)
          .then((json) => {
            commit('updatefundbaseinfos', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {
    currentPeriodIncrease(state, getters, rootState) {
      return state.fund[rootState.native.fund.fundCode];
    },
    currentWarnWarinfo(state, getters, rootState) {
      return state.fund[`${rootState.native.fund.fundCode}FundMNBasicInfoWarinfo`];
    },
    currentTagList(state, getters, rootState) {
      return state.fund[`${rootState.native.fund.fundCode}TagList`];
    },
    currentZBDate(state, getters, rootState) {
      return state.fund[`${rootState.native.fund.fundCode}showByProductCode`];
    },
    currentADConDate(state, getters, rootState) {
      return state.fund[`${rootState.native.fund.fundCode}ADConfigurenew`];
    },
  },
};
